import ManualPage from "./ManualPage";
import AutomaticPage from "./AutomaticPage";
import AutomaticManualPage from "./AutomaticManualPage";
import NoSettingsPage from "./NoSettingsPage";
import { useAccountSettingsStore } from "../../../../Zustand/accountSettingsStore";

export default function ComplianceDashboardPage() {
  const softwareFeatures = useAccountSettingsStore((state) => state.softwareFeatures);

  if (!softwareFeatures) {
    return <NoSettingsPage />;
  }

  return (
    <div className='m-5'>
      {(softwareFeatures.isAutomaticSystemEnabled && !softwareFeatures.isManualSystemEnabled) ?
        <AutomaticPage />
      :
      (softwareFeatures.isManualSystemEnabled && !softwareFeatures.isAutomaticSystemEnabled) ?
        <ManualPage />
      :
      (softwareFeatures.isManualSystemEnabled && softwareFeatures.isAutomaticSystemEnabled) ?
        <AutomaticManualPage />
      :
        <NoSettingsPage />
      }
    </div>
  );
}
